<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <h4 class="main-title mb-0">Check Type</h4>
            </div>
            <router-link to="/checktypes" type="submit" class="btn btn-sm btn-primary" style="float: right;"><i class="ri-list-check"></i> CHECK TYPES</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="submitForm()">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <h5 class="my-auto" v-if="status">Add Check Type</h5>
                            <h5 class="my-auto" v-else>Update Check</h5>
                        </div>
                        <div class="card-body mb-3">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label class="form-label">Check Type Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Check Type Name" class="form-control" :class="{'is-invalid':errors.check_type_name}" v-model="check_type.check_type_name"  ref="check_type_name"/>
                                    <span v-if="errors.check_type_name"><small class="text-danger">{{ errors.check_type_name[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Field Type</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Field Type" class="form-control" :class="{'is-invalid':errors.field_type}" v-model="check_type.field_type" />
                                    <span v-if="errors.field_type"><small class="text-danger">{{ errors.field_type[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Default Value</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Default Value" class="form-control" :class="{'is-invalid':errors.default_value}" v-model="check_type.default_value" />
                                    <span v-if="errors.default_value"><small class="text-danger">{{ errors.default_value[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">LCL</label>
                                    <input type="text" placeholder="LCL" class="form-control" :class="{'is-invalid':errors.lcl}" v-model="check_type.lcl" />
                                    <span v-if="errors.lcl"><small class="text-danger">{{ errors.lcl[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">UCL</label>
                                    <input type="text" placeholder="UCL" class="form-control" :class="{'is-invalid':errors.ucl}" v-model="check_type.ucl" />
                                    <span v-if="errors.ucl"><small class="text-danger">{{ errors.ucl[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Field Values</label>
                                    <input type="text" placeholder="Field Values" class="form-control" :class="{'is-invalid':errors.field_values}" v-model="check_type.field_values" />
                                    <span v-if="errors.field_values"><small class="text-danger">{{ errors.field_values[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-sm btn-danger me-2" @click="discard()"><i class="ri-close-line icon_hgt"></i>BACK</button>
                            <button v-if="status" type="submit" class="btn btn-sm btn-primary"><i class="ri-save-line icon_hgt"></i>SUBMIT</button>
                            <button v-else type="submit" class="btn btn-sm btn-primary"><i class="ri-save-line icon_hgt"></i>UPDATE</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "check_type_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                check_type: {
                    check_type_id: "",
                    check_type_name: "",
                    field_type: "",
                    default_value: "",
                    lcl: "",
                    ucl: "",
                    field_values: "",
                },
                status: true,
                errors: [],
                check_types: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.name == "CheckTypes.Create") {
                    vm.$refs.check_type_name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getChecktype", data: { check_type_id: to.params.check_type_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.check_type = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addCheckType();
                } else {
                    vm.updateCheckType();
                }
            },
           
            addCheckType() {
                let vm = this;
                let loader = this.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addChecktype", data: vm.check_type })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Check Type Added successfully");
                        vm.$router.push("/checktypes");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateCheckType() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateChecktype", data: vm.check_type })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Check Type is successfully updated");
                        vm.$router.push("/checktypes");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.check_type.check_type_id = "";
                vm.check_type.check_type_name = "";
                vm.check_type.field_type = "";
                vm.check_type.default_value = "";
                vm.check_type.lcl = "";
                vm.check_type.ucl = "";
                vm.check_type.field_values= "";
                vm.$refs.check_type_name.focus();
                vm.errors = [];
                vm.status = true;
            },
        },
    };
</script>
